import React from 'react';
export function HexagonBg({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`absolute inset-0 overflow-hidden pointer-events-none z-0 ${className}`} data-id="element-165">
      <div className="w-full h-full hex-bg" data-id="element-166"></div>
    </div>;
}